<template>
    <b-dropdown-divider />
</template>

<script>
import { BDropdownDivider } from 'bootstrap-vue'

export default {
    components: { BDropdownDivider },
}
</script>